// Chat drawer persistence + page-context derivation. Extracted from
// ChatDrawer.tsx — pure helpers with no React dependency.

import { type PageContext } from './types';

export const LS_OPEN = 'ub.chat.drawer-open';
export const LS_SESSION = 'ub.chat.active-session-id';

export function readLS(key: string): string | null {
  try { return window.localStorage.getItem(key); } catch { return null; }
}

export function writeLS(key: string, value: string | null): void {
  try {
    if (value == null) window.localStorage.removeItem(key);
    else window.localStorage.setItem(key, value);
  } catch { /* ignore */ }
}

export function derivePageContext(
  pathname: string,
  params: Record<string, string | undefined>,
): PageContext {
  if (pathname === '/') return { route: 'OPPORTUNITIES', hint: 'Dashboard' };
  if (pathname.startsWith('/opportunities/')) return { route: 'OPPORTUNITY_DETAIL', opportunityId: params.id ?? null };
  if (pathname === '/opportunities') return { route: 'OPPORTUNITIES' };
  if (pathname === '/projects') return { route: 'PROJECT_LIST' };
  if (pathname.startsWith('/projects/')) return { route: 'PROJECT_DETAIL', projectId: params.id ?? null };
  if (pathname === '/pricing') return { route: 'PRICING' };
  if (pathname.startsWith('/admin/company')) return { route: 'COMPANY' };
  if (pathname.startsWith('/admin/')) return { route: 'ADMIN' };
  return { route: 'OTHER', hint: pathname };
}
